import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-specifications',
  templateUrl: './document-specifications.component.html',
  styleUrls: ['./document-specifications.component.scss']
})
export class DocumentSpecificationsComponent implements OnInit {

  constructor(
    private location: Location
  ) { }

  public ngOnInit(): void {

    window.open('https://support.lbmx.com/hc/en-us/articles/14942135422740-LBMX-EDI-Specifications', '_blank');
    this.location.back();

  }

}
